import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslations } from "next-intl";
import { pendingDesktopAuthClient } from "@/lib/DesktopAuth";
const BANNER_HEIGHT_VAR = "--capture-setup-banner-height";
const BANNER_PATHS = new Set(["/email-verification", "/onboard", "/onboard-pricing", "/setup-channel", "/setup-channel-languages", "/setup-channel-languages-add", "/setup-branding"]);
export function showsDesktopCaptureSetupBanner(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false;
  }
  const path = pathname.split("?")[0].split("#")[0].replace(/\/+$/, "") || "/";
  return BANNER_PATHS.has(path);
}

/** Shown while a Capture signup still has account setup left. */
export default function DesktopCaptureSetupBanner() {
  const t = useTranslations();
  const bannerRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(pendingDesktopAuthClient() === "desktop_capture");
  }, []);
  useLayoutEffect(() => {
    const banner = bannerRef.current;
    if (!visible || !banner) {
      document.documentElement.style.removeProperty(BANNER_HEIGHT_VAR);
      return;
    }
    const applyHeight = () => {
      document.documentElement.style.setProperty(BANNER_HEIGHT_VAR, `${banner.offsetHeight}px`);
    };
    applyHeight();
    const observer = new ResizeObserver(applyHeight);
    observer.observe(banner);
    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty(BANNER_HEIGHT_VAR);
    };
  }, [visible]);
  if (!visible) {
    return null;
  }
  return <div ref={bannerRef} className="desktop-capture-setup-banner alert alert-primary rounded-0 mb-0 text-center py-2" role="status" data-sentry-component="DesktopCaptureSetupBanner" data-sentry-source-file="DesktopCaptureSetupBanner.tsx">
            {t("desktopCapture.setupBanner")}
        </div>;
}